import { ApiErrorSchema } from '@/lib/apiError';
import { z } from 'zod';

export type TRPCErrorShape = z.infer<typeof TRPCErrorSchema>;

export const TRPCErrorSchema = z.object({
  data: z.object({
    httpStatus: z.number(),
    zodError: z
      .array(
        z.object({
          path: z.array(z.union([z.string(), z.number()])),
          message: z.string(),
        }),
      )
      .nullable(),
    apiError: ApiErrorSchema.nullable(),
  }),
});

export const isTrpcError = (error: unknown): error is TRPCErrorShape =>
  TRPCErrorSchema.safeParse(error).success;
